class ExtrasSaveController {

    constructor($rootScope, $state, $stateParams, access) {
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$stateParams = $stateParams;
        this.access = access;
    }

    $onInit() {
        this.activeTab = this.$stateParams.tab || 'extra';
    }
}

ExtrasSaveController.$inject = [ '$rootScope', '$state', '$stateParams', 'access' ];

export default ExtrasSaveController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/controllers/extras.save.controller.js